"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ky_imlpConfig_1 = require("../config/ky.imlpConfig");
var service_status_enum_1 = __importDefault(require("../enums/service-status.enum"));
require("../helpers/environment");
var formatAssessmentResponse = function (status, response) { return ({
    status: status,
    response: response
}); };
var AssessmentService = {
    getStudentSchedule: function (studentId, schoolYear) {
        var _a;
        var url = "".concat((_a = window.STUDENT_ENV) === null || _a === void 0 ? void 0 : _a.REACT_APP_ASSESSMENT_SCHEDULER_API_URL, "/student/getTestStatus");
        var headers = {
            "Content-Type": "application/json"
        };
        var body = JSON.stringify({
            studentId: studentId,
            schoolYear: schoolYear.toString()
        });
        return (0, ky_imlpConfig_1.post)(url, { headers: headers, body: body })
            .then(function (response) {
            if (!response.ok) {
                throw new Error("HTTP error! Status: ".concat(response.status));
            }
            console.log("Response:", response);
            return response.json();
        })
            .then(function (data) {
            console.log("Data:", data);
            if (data === null || data === void 0 ? void 0 : data.schedules) {
                return formatAssessmentResponse(service_status_enum_1.default.LOADED, data.schedules);
            }
            return formatAssessmentResponse(service_status_enum_1.default.LOADED, []);
        })
            .catch(function (error) { return formatAssessmentResponse(service_status_enum_1.default.ERROR, error); });
    }
};
exports.default = AssessmentService;
